import React from "react";
import AnimatedSection from "./AnimatedSection";
import { useTranslation } from "react-i18next";
import "../i18n"; // Import i18n setup

const ManagementPolicy = () => {
  const { t} = useTranslation();

  return (
    <section id="management-policy">
            <AnimatedSection>
                <div className="flex flex-col lg:flex-row p-10">
                    <div className="w-full lg:w-1/2 p-4">
                        <h2 className="text-3xl font-bold">{t("managementPolicy.title")}</h2>
                        <p className="mt-2">
                            - Innovate with next-generation technology to transform education, real-life solutions, and aging society support.
                        </p>
                    </div>
                </div>
            </AnimatedSection>
        </section>
  );
};

export default ManagementPolicy;